// extracted by mini-css-extract-plugin
export default {"parent":"GithubStats_parent__i+dHO","first":"GithubStats_first__vWDdg","second":"GithubStats_second__FdsWv"};